import {Injectable} from '@angular/core';
import {UtilsService} from '../../utils/utils.service';
import {Auth2Service} from '../security/auth2.service';
import {FormFieldCheckboxSupplier} from '../../suppliers/form-field-checkbox-supplier';
import {FormFieldTextboxSupplier} from '../../suppliers/form-field-textbox-supplier';
import {FormFieldBaseSupplier} from '../../suppliers/form-fieldbase-supplier';
import {HttpClient} from '@angular/common/http';
import {GenericHandler} from '../generics/generic-handler';
import {Router} from '@angular/router';
import {FamillePlanAlimentaireDTO} from '../../dtos/famille-plan-alimentaire-dto';
import {Title} from '@angular/platform-browser';
import {DialogMsgSupplier} from '../../suppliers/dialog-msg-supplier';
import {FormFieldColorPickerSupplier} from '../../suppliers/form-field-colorpicker-supplier';
import {FormFieldDropdownSupplier} from '../../suppliers/form-field-dropdown-supplier';
import {ObjectDTO} from '../../dtos/object-dto';
import {startCase as _startCase} from 'lodash';


@Injectable()
export class FamillesPlansAlimentairesService extends GenericHandler<FamillePlanAlimentaireDTO> {

  getTotalRecordsLabel(): string {
    return _startCase(this.getEntityName());
  }


  getHelp() : DialogMsgSupplier {
    return undefined;
  }

  getSort(): string[] {
    return ['libelle,asc'];
  }

  getOas(): boolean {
    return undefined;
  }

  getTitle(): string {
    return 'GESTION DES FAMILLES DE PLAN ALIMENTAIRE';
  }

  getCreateNewObjectLabel(): string {
    return 'CRÉER UNE FAMILLE DE PLAN ALIMENTAIRE';
  }



  getEntityName(): string {
    return 'FamillePlanAlimentaire';
  }

  constructor(utils: UtilsService, auth2Svc: Auth2Service, router: Router, http: HttpClient,title:Title) {
    super(utils, auth2Svc, router, http,title);
  }

  getFields(dto: FamillePlanAlimentaireDTO): FormFieldBaseSupplier<any>[] {

    if(this.utils.isNullOrEmpty(dto)){
      dto = new FamillePlanAlimentaireDTO();
    }

    let formFields: FormFieldBaseSupplier<any>[] = [

      new FormFieldDropdownSupplier({
        key: 'site',
        label: 'Site',
        readonly: !this.canModifySite(dto),
        type: 'externalRef',
        value: this.utils.preSelectSingleList(this.optionsSites,dto.site),
        order: 1,
        options: this.optionsSites
      }),

      new FormFieldTextboxSupplier({
        key: 'libelle',
        label: 'Libellé',
        readonly: !this.canModify(dto),
        minLength: 2,
        maxLength: 100,
        value: dto.libelle,
        required: true,
        order: 3
      }),

      new FormFieldTextboxSupplier({
        key: 'code',
        label: 'Code',
        readonly: !this.canModify(dto),
        value: dto.code,
        maxLength: 50,
        required: false,
        order: 4
      }),

       new FormFieldColorPickerSupplier({
        key: 'couleur',
        label: 'Couleur',
        readonly: !this.canModify(dto),
        value: this.getHexColor(dto.couleur),
        type:'string',
        order: 2
      }),

      new FormFieldCheckboxSupplier({
        key: 'actif',
        label: 'Actif',
        readonly: !this.canModify(dto),
        value: dto.actif,
        required: true,
        order: 5
      }),

      new FormFieldTextboxSupplier({
        key: 'id',
        type: 'hidden',
        value: dto.id,
        order: 6
      }),


    ];

    return formFields.sort((a, b) => a.order - b.order);
  }



  getAllFromEnvironnement(): void {
  }

  createEmptyDTO(): FamillePlanAlimentaireDTO {
    return new FamillePlanAlimentaireDTO();
  }

  getEditObjectLabel(data: ObjectDTO): string {
    return `MODIFIER LA FAMILLE DE PLAN ALIMENTAIRE '${data.libelle.toUpperCase()}'`;
  }


}
